import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import _ from "lodash";
import API from "util/Api";
import ContainerHeader from "components/ContainerHeader";
import SnackBar from "components/SnackBar";
import ActionsTable from "components/ActionsTable/TableList";
import EZForm, { getFieldValues } from "components/EZForm";
import PopUpDialog from 'components/PopUpDialog';

const ParkingLocations = (props) => {
    console.log('parkingLocations props - ', props);
    const [fields, setFields] = useState();
    const [values, setValues] = useState();
    const [table, setTable] = useState();
    const [dialog, setDialog] = useState({open:false,content:'',header:'',agreeBtnTxt:'',disAgreeBtnTxt:'', type:'', valetParkingLoc:{}, callback:null});
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });
    const validations = Yup.object().shape({
        name: Yup.string().required("Required"),
        landmark: Yup.string().required("Required"),
        map: Yup.object().required("Required"),
    });

    const handleSubmit = (data, form) => {
        API.post("valetParkingLocationsV2", JSON.stringify(data))
            .then((res) => {
                setTable(res.data.data);
                form.setSubmitting(false);
                form.resetForm();
                setSnackBar({
                    open: true,
                    message: res.data.msg,
                    type: "success",
                });
            })
            .catch((err) => {
                console.log("error", err);
                form.setSubmitting(false);
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    };

    const handleEdit = (loc) => {
        const fieldValues = getFieldValues(Object.values(loc));
        console.log('fieldValues', fieldValues)
        setValues(fieldValues);
        // scroll to top
        document.body.style.height = "auto";
        setTimeout(function () {
            document.body.style.height = "100%";
        }, 50);
    }

    const updateStatus = (id, status, cb) => {
        API.put("valetParkingLocStatus", JSON.stringify({ id: id, active: status }))
            .then((res) => {
                cb(status)
            })
            .catch((err) => {
                console.log("error", err);
            });
        handleDialogClose();
    };

    const updateActiveStatus = (id, checked, cb)=> {
        let valetParkingLoc = _.find(table.body, (valetParkingLoc) => valetParkingLoc.id.value === id);

        setDialog({
            open:true,
            header:`${checked == true ? 'Activate': 'Deactivate'} Valet Parking Location`,
            content:`Are you sure you want to ${checked ? 'activate': 'deactivate'} ${valetParkingLoc.name.value}?`,
            agreeBtnTxt:'Confirm',
            disAgreeBtnTxt:'Cancel',
            type:'updateActiveStatus',
            valetParkingLoc:{id:id, active:checked},
            callback:cb
        });
    }

    const confirmDialogSubmit = (type) =>{
        if(type === 'updateActiveStatus'){
            updateStatus(dialog.valetParkingLoc.id, dialog.valetParkingLoc.active, dialog.callback);
        }
    }

    const handleDialogClose = ()=>{
        setDialog({
            open:false,
            content:'',
            header:'',
            agreeBtnTxt:'',
            disAgreeBtnTxt:'',
            type:'',
            valetParkingLoc: {},
            callback:null
        });
    }

    useEffect(() => {
        API.get("valetParkingLocationsV2")
            .then((res) => {
                setFields(res.data.data.config?.fields);
                setTable(res.data.data.table);
            })
            .catch((err) => {
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    }, []);

    return (
        <>
            <ContainerHeader title={"Valet Parking Locations"} match={props.match} />
            {fields && <EZForm
                fields={fields}
                values={values}
                onSubmit={handleSubmit}
                validationSchema={validations}
            />}
            {table && <ActionsTable
                tableHeading={table?.title}
                table={table}
                onEdit={handleEdit}
                updateStatus={updateActiveStatus}
                actions={true}
            />}
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message:"" });
                }}
            />
            <PopUpDialog
                fullWidth
                open={dialog.open}
                header={dialog.header}
                content ={dialog.content}
                agreeBtnTxt ={dialog.agreeBtnTxt}
                disAgreeBtnTxt={dialog.disAgreeBtnTxt}
                agreeClicked ={() =>confirmDialogSubmit(dialog.type)}
                handleDialogClose={handleDialogClose}
            />    
        </>
    )
}
export default ParkingLocations;